var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"return",on:{"click":_vm.clickReturn}},[_c('img',{attrs:{"src":"/images/icons/Return.png","alt":"戻る"}})])}
var staticRenderFns = []

export { render, staticRenderFns }